'use client'
import { useTranslations } from 'next-intl'
import React, { useEffect, useRef, useState } from 'react'
import { ConstantService } from 'src/constants/apiPaths'
import { useParams } from 'next/navigation'
import { useGeoCodeAddress, useHomeList } from 'src/lib/api/homeService'
import { HelperService } from 'src/lib/api'
import { CompilerProvider } from 'src/lib/api/complierProvider'
import { motion } from 'framer-motion'
import 'slick-carousel/slick/slick.css'
import 'slick-carousel/slick/slick-theme.css'
const Slider = dynamic(() => import('react-slick'), { ssr: false })
import FleetsCardsSkeleton from './FleetsCardsSkeleton'
import FleetsCardsLayout from './FleetsCardsLayout'
import getSlickSettings from 'src/constants/slickSettings'
import dynamic from 'next/dynamic'
import { ChevronLeft, ChevronRight } from 'lucide-react'
import FleetTabs from './FleetTabs'

const CarRentalsFleet = ({
  isShowSkeletonTabs,
  isShowRate,
  changeCurrLoading,
  isFleetByLocationPage,
  isHideTabs,
  searchedFleetData,
  isElectricPage,
  tabsAlignment = 'center',
}) => {
  const helperService = new HelperService()
  const compilerProviderInst = new CompilerProvider(helperService)
  const t = useTranslations('all-fleet-types')
  const { city } = useParams()
  const [form, setForm] = useState({})
  const [data, setData] = useState({})
  const [activeTab, setActiveTab] = useState({ key: 'City', index: 0 })
  const [activeData, setActiveData] = useState([])
  const [horizontalScrollPercentage, setHorizontalScrollPercentage] =
    useState(0)
  const [hasInitialized, setHasInitialized] = useState(false)
  const checkCardsNumber = isHideTabs
    ? data.length
    : data[activeTab.key]?.length
  const sliderSettings = getSlickSettings(checkCardsNumber, 'default')
  const { geoData, error, isLoading } = useGeoCodeAddress(city || 'london')
  const { fetchHomeList, loading } = useHomeList(form)
  const currencyList = ConstantService.currency
  const selectedCurrency = currencyList[0]
  useEffect(() => {
    setHorizontalScrollPercentage(0)
  }, [])
  useEffect(() => {
    if (
      (searchedFleetData && isFleetByLocationPage) ||
      (searchedFleetData && isElectricPage)
    ) {
      setData(searchedFleetData)
    }
  }, [searchedFleetData])
  useEffect(() => {
    const initializeData = async () => {
      if (
        geoData &&
        !hasInitialized &&
        !isFleetByLocationPage &&
        !isElectricPage
      ) {
        setHasInitialized(true)

        setForm({
          address: geoData.results[0]?.formatted_address,
          currency: selectedCurrency.value,
        })

        const data = {
          address: geoData.results[0]?.formatted_address,
          coordinates: `${geoData.results[0]?.geometry.location.lat}/${geoData.results[0]?.geometry.location.lng}`,
          placeId: geoData.results[0]?.place_id,
          currency: selectedCurrency.value,
        }

        try {
          const fetchedData = await fetchHomeList()
          const homeData = compilerProviderInst.constructHomeData(
            fetchedData.data
          )
          const selfDriveGroups = helperService.groupBy(
            homeData.selfDrive,
            'type'
          )
          const union = (await import('lodash/union')).default

          const sortedChauffeurGroup = {
            City: union(selfDriveGroups['city']),
            Convertible: union(selfDriveGroups['convertibles']),
            Electric: selfDriveGroups['electric'],
            SUV: selfDriveGroups['suvs'],
            Executive: selfDriveGroups['executives'],
            Sports: union(selfDriveGroups['sports']),
            Supercar: selfDriveGroups['supercar'],
            Classic: selfDriveGroups['classic'],
            Van: selfDriveGroups['van'],
          }
          setActiveTab({ key: 'City', index: 0 })
          setData(sortedChauffeurGroup)
          setHorizontalScrollPercentage(sortedChauffeurGroup)
        } catch (error) {
          console.error('Error fetching home list:', error)
        }
      }
    }

    initializeData()
  }, [
    geoData,
    selectedCurrency.value,
    hasInitialized,
    fetchHomeList,
    helperService,
    horizontalScrollPercentage,
  ])
  return Object.keys(data).length ? (
    <div
      className={`w-full max-w-full md:min-h-fit min-h-[340px] ${
        isElectricPage ? 'electric-page' : ''
      }`}
    >
      <FleetTabs
        isHideTabs={isHideTabs}
        tabsAlignment={isHideTabs}
        data={data}
        activeTab={activeTab}
        setActiveTab={setActiveTab}
      />
      <div>
        <Slider {...sliderSettings}>
          {!isFleetByLocationPage && !isElectricPage
            ? data[activeTab.key]?.map((item, index) => (
                <FleetsCardsLayout
                  item={item}
                  key={item.name + index}
                  index={index}
                  activeTab={activeTab}
                  changeCurrLoading={changeCurrLoading}
                  isShowRate={isShowRate}
                  isDailyRate={true}
                />
              ))
            : data?.map((item, index) => (
                <FleetsCardsLayout
                  item={item}
                  key={item.name + index}
                  index={index}
                  activeTab={activeTab}
                  changeCurrLoading={changeCurrLoading}
                  isShowRate={isShowRate}
                  isDailyRate={true}
                />
              ))}
        </Slider>
      </div>
    </div>
  ) : (
    <FleetsCardsSkeleton
      isShowSkeletonTabs={isShowSkeletonTabs}
      tabsAlignment={tabsAlignment}
    />
  )
}

export default CarRentalsFleet
